<template>
  <div class="c-group g-container">
    <Breadcrumb class="m-bread">
      <BreadcrumbItem> <Icon type="ios-home-outline" size="18"></Icon> 选择投放账号 </BreadcrumbItem>
    </Breadcrumb>

    <!-- 滚动区域 -->
    <div class="module-content" ref="container">
      <moduler v-for="item in subModules" :key="item.id" :name="item.href" :title="item.name">
        <!-- 广告账号选择 -->
        <div v-if="item.href === 'group_creat'">
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">批量方案</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="campaign.subject" type="button" @on-change="changeSubject">
                <Radio :label="1" disabled>一个推广计划对应多个计划创意</Radio>
                <Radio :label="2">一个推广计划对应一个计划创意</Radio>
              </RadioGroup>
              <Button type="primary" style="margin-left: 22px" disabled @click="model = true">新建推广计划</Button>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">推广目标</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="campaign.promoted_object_type" type="button" @on-change="changeLandType">
                <Radio :label="1">网站链接</Radio>
                <Radio :label="2">应用下载(iOS)</Radio>
                <Radio :label="3">应用下载(Andriod)</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <!-- 一对一 -->
          <template v-if="campaign.subject === 2">
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">推广计划预算</span>
              </Col>
              <Col span="12">
                <RadioGroup v-model="campaign.budgetMode" type="button" @on-change="changBudget">
                  <Radio :label="0">不限</Radio>
                  <Radio :label="1">指定预算</Radio>
                </RadioGroup>
              </Col>
            </Row>
            <Row class="row-item" :gutter="12" v-if="campaign.budgetMode === 1">
              <Col span="3" class="col-item">
                <span class="item-field row-item-must">日预算</span>
              </Col>
              <Col span="12">
                <input-number-plus
                  v-model="campaign.budget"
                  :max="7"
                  :min="50"
                  :step="0.1"
                  :precision="2"
                  :width="499"
                  placeholder="请输入50-9,999,999.99数值"
                />
                <span style="padding: 0 6px"> 元 </span>
              </Col>
            </Row>
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">推广日期</span>
              </Col>
              <Col span="12">
                <RadioGroup v-model="campaign.timeType" type="button" @on-change="changeTime">
                  <Radio label="NONE">不限</Radio>
                  <Radio label="CUSTOM">指定日期</Radio>
                </RadioGroup>
              </Col>
            </Row>
            <Row class="row-item" :gutter="12" v-if="campaign.timeType === 'CUSTOM'">
              <Col span="3" class="col-item">
                <span class="item-field">&nbsp;</span>
              </Col>
              <Col span="12">
                <Row :gutter="12">
                  <Col span="24">
                    <DatePicker
                      type="date"
                      :value="campaign.starttime"
                      placeholder="请选择开始日期"
                      style="width: 160px"
                      :options="{ disabledDate: startOption }"
                      @on-change="changeStartTime"
                    ></DatePicker>
                    <span class="m-date-split">~</span>
                    <DatePicker
                      type="date"
                      :value="campaign.endtime"
                      placeholder="请选择结束日期"
                      style="width: 160px"
                      :options="{ disabledDate: endOption }"
                      @on-change="changeEndTime"
                    ></DatePicker>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">推广时段</span>
              </Col>
              <Col span="12">
                <RadioGroup v-model="campaign.timeRange" type="button" @on-change="radioChange('weektimeData')">
                  <Radio label="NONE">不限</Radio>
                  <Radio label="RANGE">指定时段</Radio>
                </RadioGroup>
              </Col>
            </Row>
            <Row v-if="campaign.timeRange === 'RANGE'" class="row-item" :gutter="12">
              <Col span="3" class="col-item">&nbsp;</Col>
              <Col span="18">
                <drag-weektime v-model="mult_timeRange" :data="DATA.weektimeData" :colspan="1" @on-clear="clearWeektime" />
              </Col>
            </Row>
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">投放速度</span>
              </Col>
              <Col span="12">
                <RadioGroup v-model="campaign.bgtctltype" type="button">
                  <Radio :label="1">标准</Radio>
                  <Radio :label="0">平衡投放</Radio>
                  <Radio :label="2">展现优先</Radio>
                </RadioGroup>
              </Col>
            </Row>
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">推广计划名称</span>
              </Col>
              <Col span="12">
                <Input placeholder="名称无需填写，自动和计划单元名称一致" readonly style="width: 399px" />
              </Col>
            </Row>
          </template>

          <Row class="row-item" :gutter="12" v-if="campaign.subject === 1 && campaignIds.length">
            <Col span="3" class="col-item">
              <span class="item-field">账号/推广计划选择</span>
            </Col>
            <Col span="20">
              <Spin size="large" fix v-if="show" />
              <select-group
                v-else
                v-model="multCampaign"
                account
                :data="campaignIds"
                :media="media"
                :type="campaign.promoted_object_type"
                @on-select="selectAll"
              />
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-else-if="campaign.subject === 2 && accountIds.length">
            <Col span="3" class="col-item">
              <span class="item-field">账号选择</span>
            </Col>
            <Col span="16">
              <Spin size="large" fix v-if="show" />
              <select-account v-else v-model="multAccount" :data="accountIds" :media="media" @on-select="selectAll" />
            </Col>
          </Row>
        </div>
      </moduler>
    </div>

    <affix target="c-create-scroll" :offsetBottom="0">
      <div class="c-group-submit">
        <Row :gutter="12">
          <Col span="12">
            <error-pop v-model="formErr" :state="Boolean(errRes.length)" :data="errRes" @on-close="errRes = []"></error-pop>
          </Col>
          <Col span="12" class="c-btns-submit">
            <Button type="primary" :loading="loading" @click.stop="submitToNext">
              <span v-if="!loading">下一步</span>
              <span v-else>提交中...</span>
            </Button>
          </Col>
        </Row>
      </div>
    </affix>

    <!-- 批量增加广告组 -->
    <batch-add v-model="model" :data="originData" :game-data="gameData" :loading="asyning" @on-batch="asyncSelect" />

    <Modal v-model="result" width="620" title="推广计划创建结果" okText="知道了">
      <p>
        成功创建 <strong style="color: green">{{ resultData.length - fail }}</strong> 条,失败
        <strong style="color: red">{{ fail }}</strong> 条
      </p>
      <Table :columns="resultColumns" :data="resultData" :max-height="420"></Table>
    </Modal>
  </div>
</template>
<script>
import moment from 'moment'
import mixin from './mixin'
import { setSession, setLocal, getLocal } from '@/common/js/api'
import { isArray, getTime, getIdOfData, findCheck, splicing, deepCopy, timeout, clearTagOfData } from '@/common/js/utils'

import weektimeData from '@/data/baidu/weektime_data'
import DragWeektime from '@/components/drag/drag-weektime.vue'
import SelectGroup from './components/group/select-group'
import SelectAccount from './components/group/select-account'
import BatchAdd from './components/group/add-group'

import { adAccount, getCaoHuaGames } from '@/api/common.model'
import { addCampaignBatch } from '@/api/baidu.local.model'

const unsplicing = (list) => {
  let same
  let i = -1
  const len = list.length
  const arr = []

  if (!len) return
  while (++i < len) {
    const item = list[i]
    if (!item.check) {
      if (item.check === Boolean(same)) {
        arr.push(...['、', item.begin, '~', item.end])
      } else if (arr.length) {
        arr.pop()
        arr.push(item.end)
      }
    }
    same = Boolean(!item.check)
  }
  arr.shift()
  return arr.join('')
}

export default {
  name: 'bdLocalGroup',
  mixins: [mixin],
  components: {
    DragWeektime,
    SelectGroup,
    SelectAccount,
    BatchAdd
  },
  computed: {
    multCampaign() {
      const arr = []
      this.campaignIds.forEach((ret) => {
        if (isArray(ret.children)) {
          ret.children.forEach((met) => {
            if (met.check) arr.push(met)
          })
        }
      })
      return arr
    },
    multAccount() {
      return findCheck(this.accountIds)
    },
    startOption() {
      return (date) => {
        return date && date.valueOf() < Date.now() - 86400000
      }
    },
    endOption() {
      return (date) => {
        return date && date.valueOf() < getTime(this.campaign.starttime)
      }
    },
    mult_timeRange() {
      return this.DATA.weektimeData.map((item) => {
        return {
          id: item.row,
          week: item.value,
          value: splicing(item.child)
        }
      })
    },
    fail() {
      return this.resultData.filter((ret) => ret.status).length
    }
  },
  data() {
    return {
      show: null,
      model: null, // 批量弹窗
      asyning: null, // 异步加载
      campaignIds: [],
      accountIds: [],
      originData: [], // 原始数据用于还原
      gameData: [],
      result: null,
      resultColumns: [],
      resultData: [],
      DATA: {
        weektimeData: deepCopy(weektimeData) // 时间区域
      },

      campaign: {
        subject: 2, // 仅批量广告
        promoted_object_type: Number(getLocal('baidu_promoted_object_type')) || 2,
        budgetMode: 0,
        timeType: 'NONE',
        timeRange: 'NONE',
        bgtctltype: 1,
        bstype: 1,
        budget: 0
      }
    }
  },
  methods: {
    selectAll({ list, check = true, current = '' }) {
      let data
      const setAllChecked = (data, check) => {
        // 无限递归
        data.forEach((ret) => {
          if (ret.children && ret.children.length) setAllChecked(ret.children, check)
          if (!ret.disabled) this.$set(ret, 'check', check)
        })
      }
      if (current) {
        const item = getIdOfData(list, current)
        data = item.children
      } else data = list
      if (isArray(data)) setAllChecked(data, check)
    },
    // 处理7*24位值
    getWeektime(val) {
      const data = []
      for (const item of val) {
        const keys = unsplicing(item.child)
        if (keys) {
          if (keys.indexOf('、') > 0) {
            const some = keys.split('、')
            some.map((ret) => {
              const h = ret.indexOf('~') > 0 && ret.split('~')
              data.push({ weekDay: item.row + 1, startHour: h && parseInt(h[0]), endHour: h && parseInt(h[1]) })
            })
          } else if (keys.indexOf('~') > 0) {
            const h = keys.split('~')
            data.push({ weekDay: item.row + 1, startHour: h && parseInt(h[0]), endHour: h && parseInt(h[1]) })
          }
        }
      }
      return data
    },
    clearWeektime() {
      this.DATA.weektimeData.forEach((item) => {
        item.child.forEach((t) => {
          this.$set(t, 'check', false)
        })
      })
    },
    changeTime(val) {
      let starttime
      let endtime
      if (val === 'CUSTOM') {
        starttime = moment().format('YYYY-MM-DD')
        endtime = moment().add(7, 'days').format('YYYY-MM-DD')
      }
      this.$set(this.campaign, 'starttime', starttime)
      this.$set(this.campaign, 'endtime', endtime)
    },
    changeStartTime(val) {
      const start = getTime(val)
      const end = getTime(this.campaign.endtime)
      if (end < start) this.$set(this.campaign, 'endtime', moment(val).add(7, 'days').format('YYYY-MM-DD'))
      this.$set(this.campaign, 'starttime', val)
    },
    changeEndTime(val) {
      this.$set(this.campaign, 'endtime', val)
    },
    changeSubject(val) {
      this.$set(this.campaign, 'bgtctltype', val === 1 ? undefined : 1)
      this.$set(this.campaign, 'budgetMode', val === 1 ? undefined : 0)
      this.$set(this.campaign, 'budget', val === 1 ? undefined : 0)
      this.$set(this.campaign, 'timeType', val === 1 ? undefined : 'NONE')
      this.$set(this.campaign, 'timeRange', val === 1 ? undefined : 'NONE')
      this.campaignIds = deepCopy(this.originData).map((ret) => {
        return { id: ret.id, name: ret.name, children: [], xhr: false, disabled: false }
      })
      this.accountIds = deepCopy(this.originData).map((ret) => {
        return { id: ret.id, name: ret.name, children: [] }
      })
    },
    changBudget(val) {
      this.$set(this.campaign, 'budget', val ? '' : 0)
    },
    changeLandType() {
      this.preloadData()
    },
    radioChange(defautData) {
      clearTagOfData(this.DATA[defautData], this)
    },
    asyncSelect(params) {
      this.resultData = []
      this.asyning = true
      addCampaignBatch(params)
        .then((data) => {
          this.asyning = false
          if (isArray(data)) {
            this.model = false
            this.preloadData()
            // 弹窗表格
            timeout(600).then(() => {
              this.result = true
              this.resultData = data
            })
          }
        })
        .catch((err) => {
          console.error(err)
          this.asyning = false
        })
    },
    valid() {
      const rules = [
        {
          name: 'campaign/budget',
          require: true,
          relyon: 'campaign/budgetMode',
          relyvalue: 1,
          min: 50,
          max: 9999999.99,
          desc: '推广计划预算'
        },
        {
          name: 'campaign/starttime',
          require: true,
          relyon: 'campaign/timeType',
          relyvalue: 'CUSTOM',
          min: 1,
          desc: '推广日期'
        },
        {
          name: 'campaign/endtime',
          require: true,
          relyon: 'campaign/timeType',
          relyvalue: 'CUSTOM',
          min: 1,
          desc: '推广日期'
        },
        {
          name: 'campaign/schedule',
          require: true,
          relyon: 'campaign/timeRange',
          relyvalue: 'RANGE',
          min: 1,
          desc: '推广时段',
          msg: '推广时段全部选择时，请选择 “不限” '
        },
        {
          name: 'multCampaign',
          require: true,
          relyon: 'campaign/subject',
          relyvalue: 1,
          min: 1,
          desc: '推广计划'
        },
        {
          name: 'multAccount',
          require: true,
          relyon: 'campaign/subject',
          relyvalue: 2,
          min: 1,
          desc: '账号'
        }
      ]
      return this.invalid(rules)
    },
    submitToNext() {
      let temAccount
      this.formErr = false
      this.errRes = this.valid() // 表单验证

      if (this.errRes.length) {
        this.formErr = true
        return
      }

      // 提交时写入session
      if (this.campaign.subject === 1) {
        temAccount = this.campaignIds.filter((ret) => ret.children.some((met) => met.check))
        setSession('campaign_ids', this.multCampaign)
      } else {
        temAccount = this.multAccount
      }
      setSession('ad_account_ids', temAccount) // 设置账号
      setSession('campaign', this.campaign)
      setLocal('baidu_promoted_object_type', this.campaign.promoted_object_type)
      // setSession('batch_task_type', this.campaign.subject)
      // setSession('campaign_type', this.campaign.campaign_type)
      this.$router.push({ name: 'baidulocalplan' })
    },
    preloadData() {
      this.show = true
      Promise.all([getCaoHuaGames(), adAccount({ mediaId: this.media, authFlag: 1 })])
        .then((data) => {
          const [games, accounts] = data
          isArray(games) && (this.gameData = games)
          if (isArray(accounts)) {
            this.originData = JSON.parse(JSON.stringify(accounts))
            this.campaignIds = deepCopy(this.originData).map((ret) => {
              return { id: ret.id, name: ret.name, children: [], xhr: false, disabled: false }
            })
            this.accountIds = deepCopy(this.originData).map((ret) => {
              return { id: ret.id, name: ret.name, children: [] }
            })
          }
          this.show = false
        })
        .catch(() => {
          this.show = false
        })
    }
  },
  watch: {
    // 投放时间段
    'DATA.weektimeData': {
      handler(nVal) {
        this.$set(this.campaign, 'schedule', this.getWeektime(nVal))
      },
      deep: true
    }
  },
  created() {
    this.preloadData()
    this.resultColumns = [
      {
        maxWidth: 80,
        title: '媒体',
        key: 'media_name'
      },
      {
        title: '名称',
        key: 'name'
      },
      {
        title: '结果',
        tooltip: true,
        key: 'msg'
      }
    ]
  }
}
</script>
<style lang="scss" scoped>
.c-group {
  height: inherit;

  .m-bread {
    line-height: 20px;
    margin-bottom: 12px;
  }

  .module-content {
    overflow-y: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
    height: calc(100% - 96px);

    .m-date-split {
      line-height: 32px;
      font-size: 16px;
      display: inline-block;
      padding: 0 8px;
    }
  }

  ::v-deep .row-item {
    align-items: flex-start;

    span.item-field {
      height: 32px;
      line-height: 32px;
    }

    .col-pull-right {
      text-align: right;
    }
  }

  .c-group-submit {
    padding: 15px;
    min-width: 1130px;
    background-color: #fff;
    border: 1px solid #eaeaea;
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 #eff1fa;

    .c-btns-submit {
      text-align: right;

      button {
        margin-left: 8px !important;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
}
</style>
